// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/pointers/hand_pointer.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/kim.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("@assets/shop/slider_bar.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("@assets/shop/slider_handle.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../public/pointers/general_pointer.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../public/pointers/attack_pointer.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../public/pointers/spell_pointer.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../public/pointers/item_cursor.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.firebase-emulator-warning {
  display: none;
}

:root {
  --game-pointer: url(${___CSS_LOADER_URL_REPLACEMENT_0___}), auto;
}

html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  font-family: Arial, sans-serif;
}

canvas {
  display: block;
  margin: 0 auto;
}

#root,
#scene {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}


#root {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  /* height: auto; */
  z-index: 1;
}

.box {
  border-bottom-left-radius: 15px;
  /* Bottom left corner rounded */
  border-bottom-right-radius: 15px;
  /* Bottom right corner rounded */
  background: linear-gradient(rgba(10, 10, 10, 0.7), rgba(20, 20, 20, 0.7));
  /* Dark grey, almost black background with slight transparency */
  border: none;
  /* Remove default borders */
  padding: 10px;
  color: white;
}

.box::before {
  content: "";
  /* Pseudo-elements require a content property, even if it's an empty string */
  position: absolute;
  /* To position it at the top */
  left: 0;
  top: 0;
  height: 3px;
  /* The thickness of your border */
  width: 100%;
  /* To cover the full width of the box */
  background: linear-gradient(to right, rgb(255, 191, 0), orange 90%);
  /* Adjusted gradient colors and positions */
}

@font-face {
  font-family: 'Kim';
  /* src: url('../../public/kim.otf') format('opentype'); */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('opentype');
}

.player-main {
  display: flex;
  flex-direction: column;
  /* This will stack the items vertically */
  align-items: flex-start;
  gap: 10px;
  /* adjust as needed */
  margin-bottom: 10px;
}

.player-content {
  display: flex;
  gap: 10px;
  /* adjust as needed */
}

.player-info {
  margin-bottom: 5px;
  margin-left: 1px;
  font-weight: bold;
  font-family: 'Kim';
  font-size: 20px;
}

.player-class {
  border-right: 2px solid white;
}

.player-portrait {
  position: relative;
  border: 3px solid gold;
  width: 50px;
  height: 84px;
  margin-top: 2px;
  background-position: -45px -45px;
  background-repeat: no-repeat;
}


.badge {
  border: 2px solid black;
  border-radius: 5px;
  padding: 2px;
  padding-left: 5px;
  padding-right: 6px;
  background-color: #4a4947;
  font-weight: bold;
  width: 100px;
  font-family: 'Kim';
  color: white;
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
}

.badge-label {
  border-right: 1px solid black;
  padding-right: 10px;
  margin-right: 10px;
  text-align: center;
}

.cooldown {
  /* background-color: #AD8606; */
  background-color: #ffc400;
}

.hp {
  background-color: #32CD32;
}

.dmg {
  background-color: #FF0000;
}

.mp {
  background-color: #0099ff;
}

.atk {
  background-color: #CD5C5C;
}

.def {
  background-color: #FFA07A;
}

.spatk {
  background-color: #9370DB;
}

.spdef {
  background-color: #20B2AA;
}

.target {
  background-color: #FAD7A0;
}

.hp,
.mp,
.cooldown,
.dmg,
.target {
  display: flex;
  align-items: center;
  border: 2px solid black;
  border-radius: 5px;
  padding: 2px;
  padding-left: 5px;
  font-weight: bold;
}

.hp-label,
.mp-label,
.cooldown-label {
  border-right: 1px solid black;
  padding-right: 10px;
  margin-right: 10px;
}

.hp-amount,
.mp-amount,
.cooldown-amount {
  padding-right: 10px;
  margin-right: 10px;
  font-style: italic;
}

.cooldown-amount {
  border-right: 1px solid black;
}

.cooldown-state {
  /* padding-right: 10px; */
  margin-right: 10px;
}

@keyframes blink {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.cooldown-complete {
  animation: blink 1s linear infinite;
}

.player-skills,
.player-items {
  margin-top: 10px;
}

.slots {
  display: flex;
  align-items: center;
}

.slots-header {
  font-family: 'Kim', sans-serif;
  border-top: 2px solid white;
  border-bottom: 2px solid white;
  background: linear-gradient(to right, rgba(0, 0, 139, 0.553), rgba(173, 216, 230, 0.498), transparent);
  color: white;
  padding: 1px 0;
  padding-left: 3px;
  margin-bottom: 5px;
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
}

.item-icon {
  width: 32px;
  height: 32px;
  background-repeat: no-repeat;
  border-radius: 6px;
}

.item-icon-pointer {
  cursor: var(--game-pointer);
}

.item-icon-off {
  filter: grayscale(1);
}

.key-binding {
    position: absolute;
    bottom: 0px;
    right: 4px;
    color: white;   
    font-size: 14px; 
    text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
    font-family: 'Kim';
}

.item-qty {
  position: absolute;
  bottom: -1px;
  left: 2px;
  font-size: 14px;
  background-color: rgba(0, 0, 0, 0.5);
  /* Black background with 50% opacity */
  border-radius: 10px;
  color: white;
}

.info-box {
  position: absolute;
  top: 110%;
  /* Positioned above the parent element */
  left: 10px;
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s, opacity 0.2s linear;
  /* Fade in/out */
  z-index: 1;
}

.skill:hover .info-box,
.item:hover .info-box {
  visibility: visible;
  /* Visible when parent is hovered over */
  opacity: 1;
}

.info-box-title {
  margin-top: 0;
}

.info-box-desc {
  margin-top: 3px;
  font-weight: normal;
  font-size: 12px;
}

.mini {
  margin-top: 5px;
  display: inline-block;
}

@keyframes flash {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.5;
  }

  100% {
    opacity: 1;
  }
}

.flash-effect {
  animation: flash 0.2s ease infinite;
}



.flex-grow {
  flex-grow: 1;
}



.member-portrait {
  position: relative;
  width: 50px;
  height: 50px;
}

.member-name {
  font-size: 12px;
}

.member-index {
  position: absolute;
  top: 0px;
  right: 0px;
  color: white;
  /* Or any color that matches your design */
  font-size: 10px;
  /* Adjust as needed */
  background-color: rgba(0, 0, 0, 0.5);
  /* Black background with 50% opacity */
  border-radius: 10px;
}


.hp-fill {
  height: 100%;
  background-color: #32CD32;
  /* green color for the filled part */
  border-radius: 5px;
  /* makes the bar rounded */
}


.mp-fill {
  height: 100%;
  background-color: #0099ff;
  border-radius: 5px;
  /* makes the bar rounded */
}


.cooldown-fill {
  height: 100%;
  background-color: #ffc400;
  border-radius: 5px;
  /* makes the bar rounded */
}

.blink {
  animation: blink 0.25s linear;
  animation-iteration-count: 3;
}

.homePage {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.content {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  background-color: #080c15;
  background-repeat: no-repeat;
  background-position: 150% -100%;
}

.notificationBar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 25px;
  background-color: #373636;
  border-bottom: 2px solid black;
}

.mainContent {
  flex: 1;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
  padding: 36px 0;
}

.page-header {
  display: flex;
  align-items: center;
  padding: 5px;
  justify-content: space-between;
}

.left-group {
  display: flex;
  align-items: center;
  /* Align items vertically in the center */
  flex: 1;
  justify-content: flex-start;
  /* Align items to the start (left) */
}

.left-group,
.right-group {
  flex: 1;
}

.header-capsules {
  /* Centered content, adjust flex-basis to control width */
  flex: 0 1 auto;
}

.page-icon {
  scale: 0.7;
}

.page-title {
  margin-left: 10px;
  font-size: 4em;
  /* Adjust as needed */
  font-family: Kim;
  color: white;
  text-shadow: -5px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
}

.gold-container {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  border-radius: 50px;
  padding: 10px 20px;
  font-weight: bold;
  border: 1px solid #CD853F;
  font-size: 30px;
  color: white;
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
  font-family: Kim;
}

.gold-container::before,
.gold-container::after {
  content: "";
  position: absolute;
  height: 10px;
  width: 10px;
  /* Adjust to create the desired gap size */
  background-color: #070507;
  /* Match the background color */
}

.gold-container::before {
  left: -12px;
  /* Position the pseudo-element to cover the left border */
}

.gold-container::after {
  right: -12px;
  /* Position the pseudo-element to cover the right border */
}

.gold-icon {
  margin-right: 10px;
  /* Space between the icon and the text */
  /* scale: 0.25; */
  height: 32px;
}

.notificationBarButton {
  position: relative;
  display: inline-flex;
  align-items: center;
  color: lightgrey;
  padding: 5px;
  cursor: pointer;
  font-size: 14px;
  background-color: #080c15;
  border-radius: 3px;
  margin-right: 5px;
  font-weight: bold;
}

.notificationBarButton:hover {
  filter: brightness(1.2);
  cursor: pointer;
}

.notificationBarButton i {
  position: relative;
  margin-right: 5px;
}

.notificationBadge {
  position: absolute;
  bottom: -5px;
  left: -8px;
  padding: 2px 5px;
  border-radius: 50%;
  background-color: red;
  color: white;
  font-size: 8px;
}

.notificationList {
  position: absolute;
  top: 100%;
  right: 0;
  width: 200px;
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #B3B3B3;
  background-color: white;
  color: black;
}

.notificationItem {
  padding: 10px;
  border-bottom: 1px solid #B3B3B3;
}

.notificationItem:last-child {
  border-bottom: none;
}

@keyframes animate-sprite {
  0% {
    background-position: -40px -40px;
  }

  33% {
    background-position: -184px -40px;
  }

  66% {
    background-position: -328px -40px;
  }
}

@keyframes animate-sprite-celebrate {
  0% {
    background-position: -900px -184px;
  }

  33% {
    background-position: -1044px -184px;
  }

  66% {
    background-position: -1188px -184px;
  }
}

.character-portrait {
  height: 100px;
  /* Adjust as needed */
  width: 65px;
  position: relative;
  background-position: -40px -40px;
  background-repeat: no-repeat;
  animation: animate-sprite 0.7s steps(1) infinite;
}

.character-card {
  position: relative;
  display: flex;
  align-items: center;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  cursor: pointer;
  margin-bottom: 10px;
  margin-right: 20px;
  border: 2px solid #CD853F;
  align-items: flex-start;
  color: white;
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
}

.character-card.warrior {
  /* background: linear-gradient(to right, #FFC600, #FF8000); */
  background: linear-gradient(to right, #B22222, #FF6347);

}

.character-card.thief {
  /* background: linear-gradient(to right, #4B0082, #8A2BE2); */
  background: linear-gradient(to right, #006400, #32CD32);

}

.character-card.white-mage {
  background: linear-gradient(to right, #FFFFFF, #A9A9A9);
}

.character-card.black-mage {
  background: linear-gradient(to right, #000000, #696969);
}

.character-info {
  display: flex;
  flex-direction: column;
}

.character-name {
  font-size: 1.2em;
  font-weight: bold;
  font-family: Kim;
}

.character-class {
  font-size: 0.9em;
  font-family: Kim;
  /* color: #666; */
}

.level-badge {
  position: absolute;
  bottom: -10px;
  right: -10px;
  background-color: gold;
  color: #fff;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.8em;
  font-weight: bold;
  font-family: Kim;
  flex-direction: column;
  box-shadow: 0 0 0 5px #070507, 0 0 0 7px #CD853F;
  /* Creates a 10px transparent gap and a 2px border */
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
}


.level-badge .level-number {
  font-size: 1.2em;
}

.roster {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.logo {
  width: 50%;
  /* Adjust as needed */
  height: auto;
}

.rank-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 32px;
  width: 1024px;
  margin: 0 auto;
}

.rank-content .flexContainer {
  width: 100%;
  justify-content: space-between;
  align-items: flex-start;
}

.rank-tab-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  padding-top: 36px;
}

.leaderboard-table {
  border-collapse: separate;
  border-spacing: 0;
  border: 2px solid white;
  border-radius: 10px;
  overflow: hidden;
  width: 100%;
  margin: auto;
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
}

.leaderboard-table thead tr {
  background: linear-gradient(to right, darkblue, lightblue);
}

.leaderboard-table th {
  font-family: 'Kim', sans-serif;
  color: white;
  cursor: pointer;
}

.leaderboard-table tr:nth-child(even) {
  background-color: #e0e0e0;
}

.leaderboard-table tr:nth-child(odd) {
  background-color: #d7d7d7;
}

.leaderboard-table td {
  text-align: center;
  font-family: 'Kim';
  color: white;
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
  padding-right: 15px;
}

.leaderboard-table tr:hover {
  background-color: #c0c0c0;
  /* ddd */
}

.leaderboard-table th div {
  display: flex;
  justify-content: center;
  align-items: center;
}

.leaderboard-table th div span:last-child {
  margin-left: 5px;
}

.golden-star {
  color: gold;
}

.hidden {
  display: none;
}

.leaderboard-table tr.highlighted-row {
  background-color: gold;
  border: 2px solid black;
  margin-left: -5px;
  margin-right: -5px;
}

.button-container {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  background-color: gold;
  /* Warmer pastel color */
  border-radius: 50px;
  /* Adjust to create an elliptical shape */
  padding: 10px 20px;
  /* Adjust for size */
  font-weight: bold;
  box-shadow: 0 0 0 10px #070507, 0 0 0 12px #CD853F;
  /* Creates a 10px transparent gap and a 2px border */
  font-size: 30px;
  color: white;
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
  font-family: Kim;
}

.button-container::before,
.button-container::after {
  content: "";
  position: absolute;
  height: 10px;
  width: 10px;
  /* Adjust to create the desired gap size */
  background-color: #070507;
  /* Match the background color */
}

.button-container::before {
  left: -12px;
  /* Position the pseudo-element to cover the left border */
}

.button-container::after {
  right: -12px;
  /* Position the pseudo-element to cover the right border */
}

.button {
  cursor: pointer;
  margin: 10px;
}

.button:hover {
  filter: brightness(1.1);
}

.button:active {
  transform: scale(0.95);
}

.player-tab {
  position: relative;
  margin-top: 10px;
  margin-left: 10px;
  z-index: 2;
  /* max-width: 350px; */
  align-self: start;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  background-color: #F9F6EE;
  border-radius: 15px;
}

.player-bars {
  margin-right: 10px;
  width: 200px;
}

.character-full {
  margin-top: 20px;
  margin-left: 10px;
  position: relative;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  background-color: #F9F6EE;
  border-radius: 15px;
  width: 500px;
}

.character-header {
  position: relative;
  background: linear-gradient(to right, #874255, #edcfb7, transparent);
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
  height: 50px;
  padding: 5px;
  padding-left: 15px;
  overflow: hidden;
}

.character-header-arena {
  position: relative;
  /* background: linear-gradient(to right, #874255, #edcfb7, transparent); */
  background: linear-gradient(to right, rgb(79, 79, 227), lightblue, transparent);
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
  height: 30px;
  padding: 5px;
  padding-left: 15px;
  overflow: hidden;
  text-shadow: 2px 2px 4px black;

}

.character-header-name {
  position: absolute;
  font-family: Kim;
  color: white;
  font-size: 30px;
  /* text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black; */
  top: 0;
  text-shadow: 2px 2px 4px black;

}

.character-header-name-shadow {
  position: absolute;
  top: -30px;
  left: 15px;
  font-family: Kim;
  color: white;
  font-size: 80px;
  opacity: 0.15;
}

.character-header-class {
  position: absolute;
  top: 35px;
  left: 15px;
  font-family: Kim;
  color: white;
  font-size: 15px;
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
  font-style: italic;
}


.character-full-content {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  font-family: Kim;
  color: white;
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
}

.character-full-level {
  font-size: 20px;
}

.level-area {
  display: flex;
  width: 50%;
}

.character-full .level-badge {
  left: 10px;
  top: 70px;
}

.hud-actions {
  margin-top: -10px;
}

.xp-area {
  margin-left: 60px;
  flex-grow: 1;
}

.xp-bar-bg {
  background-color: black;
  border-radius: 50px;
  overflow: hidden;
}

.xp-bar {
  height: 5px;
  background: linear-gradient(to right, darkblue, lightblue);
  border-radius: 50px;
}

.hud-bar-bg {
  background-color: darkred;
  border-radius: 50px;
  overflow: hidden;
}

.hud-bar {
  height: 10px;
  border-radius: 50px;
}


.cooldown-bar {
  background: gold;
}

.bar-title {
  font-style: italic;
  margin-top: 2px;
}

.bigger-number {
  font-size: 25px;
  margin-left: 5px;
}

.smaller-number {
  font-size: 12px;
  margin-left: 5px;
}

.shop-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 10px;
  margin-top: 20px;
  width: calc(100% - 30px);
}

.shop-item-card {
  position: relative;
  border: 1px solid #ccc;
  background-color: #F9F6EE;
  border-radius: 15px;
  cursor: pointer;
}

.shop-item-card:hover {
  background-color: #ffffff;
}

.shop-item-image {
  width: 36px;
  height: 36px;
  min-width: 36px;
  min-height: 36px;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}

.shop-item-name {
  margin-top: 10px;
}

.shop-item-card-header {
  position: relative;
  background: linear-gradient(to right, rgb(79, 79, 227), lightblue, transparent);
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
  height: 20px;
  padding: 5px;
  padding-left: 15px;
  overflow: hidden;
  font-family: Kim;
}

.shop-item-card-name {
  position: absolute;
  top: 0;
  font-size: 20px;
  color: white;
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;

}

.shop-item-card-name-shadow {
  position: absolute;
  top: -30px;
  left: 15px;
  font-family: Kim;
  color: white;
  font-size: 80px;
  opacity: 0.15;
}

.shop-item-card-content {
  padding: 10px;
  height: 150px;
  display: flex;
}

.shop-item-card-content-info {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.shop-item-details {
  padding-left: 10px;
}

.shop-item-card-capsules {
  display: flex;
  flex-direction: row;
  margin-top: 10px;
  justify-content: flex-end;
}

.socials {
  margin-top: 20px;
}

.socials img {
  width: 64px;
  /* height: 64px; */
}

.twitterIconContainer {
  background-color: black;
  border-radius: 5px;
  /* Adjust as needed */
  padding-left: 3px;
  padding-right: 3px;
  margin-top: 2px;
}

.twitterIconContainer i {
  color: white;
}

.socials-bar {
  padding-left: 5px;
}

.stats-area {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 10px;
  margin-top: 30px;
  width: 50%;
}

.stats-badge {
  background-color: black;
  color: white;
  border-radius: 50%;
  padding: 10px;
  width: 10px;
  height: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 5px;
}

.stats-value {
  color: black;
  margin: 5px;
}

.character-full-stats {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.description-area {
  display: grid;
  align-items: start;
  grid-template-columns: repeat(2, auto);
  grid-template-rows: repeat(2, auto);
  gap: 5px;
  margin-top: 5px;
}

.dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  border: 2px solid #ccc;
  background-color: #F9F6EE;
  border-radius: 15px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  font-family: Kim;
  color: #4a4947;
}

/* .login-dialog {
  width: 300px;
} */


.closebtn {
  cursor: pointer;
  color: rgb(222, 24, 24);
  position: absolute;
  top: -10px;
  right: -8px;
  font-size: 30px;
}

.closebtn:hover {
  filter: brightness(1.2);
}

.quantity-container {
  display: flex;
}

.shop-qty {
  width: 20px;
  text-align: center;
  margin: 0 -5px;
}

.qty-button {
  margin: 0;
  padding: 0 5px;
  cursor: pointer;
}


.qty-button,
.shop-qty {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 20px;
  /* Adjust as needed */
  width: 20px;
  /* Adjust as needed */
  border: none;
  background: none;
  border: 1px solid black;
}

.small-button {
  width: 60px;
  height: 30px;
  padding: 5px;
  font-size: 25px;
  box-shadow: 0 0 0 5px #070507, 0 0 0 6px #CD853F;
  /* Creates a 10px transparent gap and a 2px border */

}

.inventory-full {
  margin-top: 20px;
  margin-left: 10px;
  position: relative;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  background-color: #F9F6EE;
  border-radius: 15px;
  width: 60%;
}

.inventory-header {
  position: relative;
  background: linear-gradient(to right, #2f150e, #d8b085, transparent);
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
  height: 50px;
  padding: 5px;
  padding-left: 15px;
  overflow: hidden;
}

.inventory-header-name {
  position: absolute;
  font-family: Kim;
  color: white;
  font-size: 45px;
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
  top: 0;
  padding-left: 100px;
  display: flex;
  justify-content: space-between;
  width: calc(100% - 120px);
}

.inventory-header-name-shadow {
  position: absolute;
  top: -30px;
  left: 15px;
  font-family: Kim;
  color: white;
  font-size: 80px;
  opacity: 0.15;
}

/* .inventory-capacity {
  font-size: 30px;
  vertical-align: middle;
} */

.inventory-header-image {
  position: relative;
  left: -10px;
  /* Adjust this value to control how much the image spills over to the left */
}

.inventory-full-content {
  padding: 10px;
  font-family: Kim;
  color: white;
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(45px, 1fr));
  grid-gap: 5px;

}

.character-inventory-container {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
  padding: 24px 0;
  flex-wrap: wrap;
  width: 100%;
  max-width: 100%;
}

.purchase-dialog {
  width: auto;
}

.purchase-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.purchase-item-name {
  font-weight: bold;
}

.purchase-quantity {
  width: 30px;
  text-align: center;
}

.purchase-quantity-selector {
  display: flex;
  align-items: center;
  margin-left: 5px;
}


.purchase-quantity-selector input.quantity {
  text-align: center;
  border-top: 1px solid #000;
  border-bottom: 1px solid #000;
}

.purchase-total {
  display: flex;
  margin-bottom: 20px;
}

.purchase-total-amount {
  font-weight: bold;
}

.purchase-buy-button {
  padding: 10px;
  border: none;
  background-color: gold;
  color: #fff;
  cursor: pointer;
  font-family: 'Kim';
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
  font-size: 20px;
  border-radius: 5px;
}

.purchase-buy-button:hover {
  filter: brightness(1.1);
}

.purchase-adjust {
  border-radius: 5px;
  cursor: pointer;
}

.endgame {
  background: linear-gradient(rgba(10, 10, 10, 0.9), rgba(20, 20, 20, 0.9));
  /* Dark grey, almost black background with slight transparency */
  position: fixed;
  z-index: 20;
  width: 100%;
  height: 100%;
  padding: 10px;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  font-family: "Kim";
}

.endgame-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.endgame-rewards {
  display: flex;
  justify-content: center;
  color: white;
  font-size: 30px;
  font-family: 'Kim';
}

.endgame-title {
  font-family: 'Kim';
  font-size: 50px;
  color: white;
  font-style: italic;
}

.endgame-title,
.endgame-spacer {
  flex-basis: content;
  flex-grow: 1;
}

.endgame-gold-logo {
  font-size: 35px;
  color: gold;
  font-style: italic;
  /* text-shadow: -1px 0 white, 0 1px white, 1px 0 white, 0 -1px white; */
  /* text-shadow: 2px 2px 10px red;  */
  margin-right: 10px;
}

.endgame-xp {
  margin-left: 10px;
}

.endgame-xp,
.endgame-gold {
  display: flex;
  align-items: center;
}

.endgame-gold-value,
.endgame-xp-value {
  padding-left: 10px;
  display: inline-block;
  min-width: 60px;
  /* Adjust this width as needed */
  text-align: right;
}

.endgame-xp-logo {
  font-size: 35px;
  color: gold;
  font-style: italic;
  /* text-shadow: -1px 0 white, 0 1px white, 1px 0 white, 0 -1px white; */
  /* text-shadow: 2px 2px 10px rgb(3, 141, 40);  */
  margin-right: 10px;
}

::-webkit-scrollbar {
  width: 8px;
  /* Adjust the width of the scrollbar */
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  /* Add your image */
}

/* Scrollbar Thumb */
::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 8px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  /* Replace with your image path */
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-size: cover;
}


.toast {
  border: 2px solid #ffbf00;
}

.tour-step {
  border: 2px solid #ffbf00;
  background-color: #242b37;
  padding: 10px;
  text-align: center;
}

.shepherd-button {
  background-color: #ffbf00;
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
  font-family: 'Kim';
  color: white;
}

.shepherd-button:not(:disabled):hover {
  background-color: #ffaa00;
  color: white;
}

.shepherd-text {
  /* font-family: 'Kim' ; */
  color: white;
}

.shepherd-arrow,
.shepherd-arrow:before {
  width: 16px;
  height: 16px;
  position: absolute;
  z-index: -1;
}

.shepherd-arrow:before {
  content: "";
  transform: rotate(45deg);
  background: #242b37;
}

/* Top arrow */
.shepherd-element[data-popper-placement^=bottom]>.shepherd-arrow:before {
  border-top: 2px solid #ffbf00;
  border-left: 2px solid #ffbf00;
}

/* Bottom arrow */
.shepherd-element[data-popper-placement^=top]>.shepherd-arrow:before {
  border-bottom: 2px solid #ffbf00;
  border-right: 2px solid #ffbf00;
}

/* Left arrow */
.shepherd-element[data-popper-placement^=right]>.shepherd-arrow:before {
  border-left: 2px solid #ffbf00;
  border-bottom: 2px solid #ffbf00;
  left: 0px;
}

/* Right arrow */
.shepherd-element[data-popper-placement^=left]>.shepherd-arrow:before {
  border-top: 2px solid #ffbf00;
  border-right: 2px solid #ffbf00;
  right: 0px;
}

.shepherd-cancel-icon {
  position: absolute;
  top: -10px;
  right: -10px;
  width: 24px;
  height: 24px;
  padding: 0;
  background: rgb(255, 68, 68);
  border-radius: 50%;
  color: white;
  font-size: 30px;
  line-height: 22px;
  text-align: center;
  cursor: pointer;
  z-index: 1;
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
  font-family: 'Kim';
}

.shepherd-cancel-icon:hover {
  background: rgb(224, 0, 0);
  color: white;
}

a:-webkit-any-link {
  text-decoration: none;
}

.normalCursor {
  cursor: url(${___CSS_LOADER_URL_REPLACEMENT_4___}), auto;
}

.pointerCursor {
  cursor: var(--game-pointer);
}

.swordCursor {
  cursor: url(${___CSS_LOADER_URL_REPLACEMENT_5___}), auto;
}

.spellCursor {
  cursor: url(${___CSS_LOADER_URL_REPLACEMENT_6___}), auto;
}

.itemCursor {
  cursor: url(${___CSS_LOADER_URL_REPLACEMENT_7___}), auto;
}

.firebaseui-container {
  text-shadow: none;
}

.anonymous-warning {
  position: fixed;
  bottom: 20px;
  left: 20px;
  z-index: 9999;
  max-width: 300px;
  font-size: 14px;

  background-color: #242b37;
  border: 1px solid #0096a1;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  text-align: center;
  padding: 10px;
  width: 400px;
  font-family: Kim;
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
  color: white;
}

.sign-up-btn-smol {
  border-radius: 8px;
  /* Rounded corners */
  color: #ffffff;
  margin-top: 10px;
  cursor: pointer;
  width: 80%;
  /* Adjust width as needed */
  text-align: center;
  transition: all 0.3s ease;
  /* Smooth hover and active transition */
  font-family: Kim;
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
  background-color: #ffcc00;
  /* Golden color */
  border: 2px solid #ffaa00;
  /* Slightly darker border for depth */
  font-size: 14px;
  padding: 6px 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  /* Depth effect */
}

.sign-up-btn-smol:hover {
  background-color: #ffaa00;
  /* Slightly darker on hover */
  border-color: #ff9900;
  /* Darker border on hover */
  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);
  /* Deeper shadow on hover */
}

.sign-up-btn-smol:active {
  transform: scale(0.95);
  /* Scale down on press */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  /* Less shadow on press */
}


.login-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.login-modal-dialog {
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  width: 90%;
  max-width: 400px;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;

  background-color: #242b37;
  border: 1px solid #0096a1;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  text-align: center;
  padding: 10px;
  width: 400px;
  font-family: Kim;
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
  color: white;
}


.dialog-content h2 {
  margin-bottom: 20px;
}

.login-header {
  text-align: center;
  margin-bottom: 20px;
}

#firebaseui-auth-container {
  width: 100%;
}


.popup-highlight {
  animation: highlight-pulse 1s ease-in-out infinite;
  position: relative;
  filter: drop-shadow(0 0 6px rgba(0, 255, 255, 0.5));
}

.feature-highlight {
  animation: highlight-pulse 1s ease-in-out infinite;
  position: relative;
  filter: drop-shadow(0 0 6px rgba(0, 255, 255, 0.5));
}

@keyframes highlight-pulse {
  0% {
    transform: scale(1);
    filter: drop-shadow(0 0 6px rgba(0, 255, 255, 0.5));
  }
  50% {
    transform: scale(1.03);
    filter: drop-shadow(0 0 12px rgba(0, 255, 255, 0.8));
  }
  100% {
    transform: scale(1);
    filter: drop-shadow(0 0 6px rgba(0, 255, 255, 0.5));
  }
}

.team-page {
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;
  padding: 0 16px;
  box-sizing: border-box;
}

.character-sheet-skeleton {
  width: 100%;
  max-width: 434px;
  margin: 2px 0;
}

.inventory-skeleton {
  width: 100%;
  max-width: 560px;
  margin: 2px 0;
}

@media (max-width: 1024px) {
  .character-inventory-container {
    padding: 16px 0;
  }
}

@media (max-width: 768px) {
  .team-page {
    padding: 0 8px;
  }
  
  .character-inventory-container {
    gap: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/style/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,6DAA8D;AAChE;;AAEA;;EAEE,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;;;AAGA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,gCAAgC;EAChC,gCAAgC;EAChC,yEAAyE;EACzE,gEAAgE;EAChE,YAAY;EACZ,2BAA2B;EAC3B,aAAa;EACb,YAAY;AACd;;AAEA;EACE,WAAW;EACX,6EAA6E;EAC7E,kBAAkB;EAClB,8BAA8B;EAC9B,OAAO;EACP,MAAM;EACN,WAAW;EACX,iCAAiC;EACjC,WAAW;EACX,uCAAuC;EACvC,mEAAmE;EACnE,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,yDAAyD;EACzD,+DAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yCAAyC;EACzC,uBAAuB;EACvB,SAAS;EACT,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gCAAgC;EAChC,4BAA4B;AAC9B;;;AAGA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,iEAAiE;AACnE;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;;EAKE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;;EAGE,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;EAGE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,8BAA8B;EAC9B,sGAAsG;EACtG,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,iEAAiE;AACnE;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,YAAY;IACZ,eAAe;IACf,iEAAiE;IACjE,kBAAkB;AACtB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,eAAe;EACf,oCAAoC;EACpC,sCAAsC;EACtC,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,wCAAwC;EACxC,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,8CAA8C;EAC9C,gBAAgB;EAChB,UAAU;AACZ;;AAEA;;EAEE,mBAAmB;EACnB,wCAAwC;EACxC,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,mCAAmC;AACrC;;;;AAIA;EACE,YAAY;AACd;;;;AAIA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,0CAA0C;EAC1C,eAAe;EACf,qBAAqB;EACrB,oCAAoC;EACpC,sCAAsC;EACtC,mBAAmB;AACrB;;;AAGA;EACE,YAAY;EACZ,yBAAyB;EACzB,oCAAoC;EACpC,kBAAkB;EAClB,0BAA0B;AAC5B;;;AAGA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;AAC5B;;;AAGA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,OAAO;EACP,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;;EAEE,OAAO;AACT;;AAEA;EACE,yDAAyD;EACzD,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,iEAAiE;AACnE;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,iEAAiE;EACjE,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,0CAA0C;EAC1C,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,yDAAyD;AAC3D;;AAEA;EACE,YAAY;EACZ,0DAA0D;AAC5D;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,gCAAgC;EAClC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,kCAAkC;EACpC;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,mCAAmC;EACrC;AACF;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,gCAAgC;EAChC,4BAA4B;EAC5B,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,YAAY;EACZ,iEAAiE;AACnE;;AAEA;EACE,6DAA6D;EAC7D,uDAAuD;;AAEzD;;AAEA;EACE,6DAA6D;EAC7D,uDAAuD;;AAEzD;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,gDAAgD;EAChD,oDAAoD;EACpD,iEAAiE;AACnE;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,iEAAiE;AACnE;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,iEAAiE;EACjE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,2BAA2B;EAC3B,sBAAsB;EACtB,wBAAwB;EACxB,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,kDAAkD;EAClD,oDAAoD;EACpD,eAAe;EACf,YAAY;EACZ,iEAAiE;EACjE,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,0CAA0C;EAC1C,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,yDAAyD;AAC3D;;AAEA;EACE,YAAY;EACZ,0DAA0D;AAC5D;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;EACV,sBAAsB;EACtB,iBAAiB;EACjB,yCAAyC;EACzC,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;EACzC,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,oEAAoE;EACpE,+BAA+B;EAC/B,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,0EAA0E;EAC1E,+EAA+E;EAC/E,+BAA+B;EAC/B,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;;AAEhC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,uEAAuE;EACvE,MAAM;EACN,8BAA8B;;AAEhC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iEAAiE;EACjE,kBAAkB;AACpB;;;AAGA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,iEAAiE;AACnE;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,0DAA0D;EAC1D,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,+EAA+E;EAC/E,+BAA+B;EAC/B,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,eAAe;EACf,YAAY;EACZ,iEAAiE;;AAEnE;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,aAAa;EACb,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,kCAAkC;EAClC,SAAS;EACT,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sCAAsC;EACtC,mCAAmC;EACnC,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;GAEG;;;AAGH;EACE,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;;AAGA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gDAAgD;EAChD,oDAAoD;;AAEtD;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;EACzC,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,oEAAoE;EACpE,+BAA+B;EAC/B,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iEAAiE;EACjE,MAAM;EACN,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;AACf;;AAEA;;;GAGG;;AAEH;EACE,kBAAkB;EAClB,WAAW;EACX,4EAA4E;AAC9E;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,iEAAiE;EACjE,aAAa;EACb,2DAA2D;EAC3D,aAAa;;AAEf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;;AAGA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,iEAAiE;EACjE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yEAAyE;EACzE,gEAAgE;EAChE,eAAe;EACf,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;;EAEb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,uEAAuE;EACvE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,uEAAuE;EACvE,gDAAgD;EAChD,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,sCAAsC;EACtC,mDAA8C;EAC9C,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,sBAAsB;EACtB,kBAAkB;EAClB,yDAAuD;EACvD,iCAAiC;EACjC,0BAA0B;EAC1B,4BAA4B;EAC5B,sBAAsB;AACxB;;;AAGA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,iEAAiE;EACjE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA,iBAAiB;AACjB;EACE,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA,eAAe;AACf;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,UAAU;EACV,4BAA4B;EAC5B,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,iEAAiE;EACjE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qDAA8D;AAChE;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qDAA6D;AAC/D;;AAEA;EACE,qDAA4D;AAC9D;;AAEA;EACE,qDAA0D;AAC5D;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,eAAe;;EAEf,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,iEAAiE;EACjE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,2BAA2B;EAC3B,kBAAkB;EAClB,yBAAyB;EACzB,uCAAuC;EACvC,gBAAgB;EAChB,iEAAiE;EACjE,yBAAyB;EACzB,iBAAiB;EACjB,yBAAyB;EACzB,qCAAqC;EACrC,eAAe;EACf,iBAAiB;EACjB,wCAAwC;EACxC,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,qBAAqB;EACrB,2BAA2B;EAC3B,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,wCAAwC;EACxC,yBAAyB;AAC3B;;;AAGA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;;EAElB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,iEAAiE;EACjE,YAAY;AACd;;;AAGA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;;AAGA;EACE,kDAAkD;EAClD,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA;EACE,kDAAkD;EAClD,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA;EACE;IACE,mBAAmB;IACnB,mDAAmD;EACrD;EACA;IACE,sBAAsB;IACtB,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,mDAAmD;EACrD;AACF;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,SAAS;EACX;AACF","sourcesContent":[".firebase-emulator-warning {\n  display: none;\n}\n\n:root {\n  --game-pointer: url('/public/pointers/hand_pointer.png'), auto;\n}\n\nhtml,\nbody {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 100%;\n  font-family: Arial, sans-serif;\n}\n\ncanvas {\n  display: block;\n  margin: 0 auto;\n}\n\n#root,\n#scene {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n\n#root {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  /* height: auto; */\n  z-index: 1;\n}\n\n.box {\n  border-bottom-left-radius: 15px;\n  /* Bottom left corner rounded */\n  border-bottom-right-radius: 15px;\n  /* Bottom right corner rounded */\n  background: linear-gradient(rgba(10, 10, 10, 0.7), rgba(20, 20, 20, 0.7));\n  /* Dark grey, almost black background with slight transparency */\n  border: none;\n  /* Remove default borders */\n  padding: 10px;\n  color: white;\n}\n\n.box::before {\n  content: \"\";\n  /* Pseudo-elements require a content property, even if it's an empty string */\n  position: absolute;\n  /* To position it at the top */\n  left: 0;\n  top: 0;\n  height: 3px;\n  /* The thickness of your border */\n  width: 100%;\n  /* To cover the full width of the box */\n  background: linear-gradient(to right, rgb(255, 191, 0), orange 90%);\n  /* Adjusted gradient colors and positions */\n}\n\n@font-face {\n  font-family: 'Kim';\n  /* src: url('../../public/kim.otf') format('opentype'); */\n  src: url('/public/kim.otf') format('opentype');\n}\n\n.player-main {\n  display: flex;\n  flex-direction: column;\n  /* This will stack the items vertically */\n  align-items: flex-start;\n  gap: 10px;\n  /* adjust as needed */\n  margin-bottom: 10px;\n}\n\n.player-content {\n  display: flex;\n  gap: 10px;\n  /* adjust as needed */\n}\n\n.player-info {\n  margin-bottom: 5px;\n  margin-left: 1px;\n  font-weight: bold;\n  font-family: 'Kim';\n  font-size: 20px;\n}\n\n.player-class {\n  border-right: 2px solid white;\n}\n\n.player-portrait {\n  position: relative;\n  border: 3px solid gold;\n  width: 50px;\n  height: 84px;\n  margin-top: 2px;\n  background-position: -45px -45px;\n  background-repeat: no-repeat;\n}\n\n\n.badge {\n  border: 2px solid black;\n  border-radius: 5px;\n  padding: 2px;\n  padding-left: 5px;\n  padding-right: 6px;\n  background-color: #4a4947;\n  font-weight: bold;\n  width: 100px;\n  font-family: 'Kim';\n  color: white;\n  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\n}\n\n.badge-label {\n  border-right: 1px solid black;\n  padding-right: 10px;\n  margin-right: 10px;\n  text-align: center;\n}\n\n.cooldown {\n  /* background-color: #AD8606; */\n  background-color: #ffc400;\n}\n\n.hp {\n  background-color: #32CD32;\n}\n\n.dmg {\n  background-color: #FF0000;\n}\n\n.mp {\n  background-color: #0099ff;\n}\n\n.atk {\n  background-color: #CD5C5C;\n}\n\n.def {\n  background-color: #FFA07A;\n}\n\n.spatk {\n  background-color: #9370DB;\n}\n\n.spdef {\n  background-color: #20B2AA;\n}\n\n.target {\n  background-color: #FAD7A0;\n}\n\n.hp,\n.mp,\n.cooldown,\n.dmg,\n.target {\n  display: flex;\n  align-items: center;\n  border: 2px solid black;\n  border-radius: 5px;\n  padding: 2px;\n  padding-left: 5px;\n  font-weight: bold;\n}\n\n.hp-label,\n.mp-label,\n.cooldown-label {\n  border-right: 1px solid black;\n  padding-right: 10px;\n  margin-right: 10px;\n}\n\n.hp-amount,\n.mp-amount,\n.cooldown-amount {\n  padding-right: 10px;\n  margin-right: 10px;\n  font-style: italic;\n}\n\n.cooldown-amount {\n  border-right: 1px solid black;\n}\n\n.cooldown-state {\n  /* padding-right: 10px; */\n  margin-right: 10px;\n}\n\n@keyframes blink {\n  0% {\n    opacity: 1;\n  }\n\n  50% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n\n.cooldown-complete {\n  animation: blink 1s linear infinite;\n}\n\n.player-skills,\n.player-items {\n  margin-top: 10px;\n}\n\n.slots {\n  display: flex;\n  align-items: center;\n}\n\n.slots-header {\n  font-family: 'Kim', sans-serif;\n  border-top: 2px solid white;\n  border-bottom: 2px solid white;\n  background: linear-gradient(to right, rgba(0, 0, 139, 0.553), rgba(173, 216, 230, 0.498), transparent);\n  color: white;\n  padding: 1px 0;\n  padding-left: 3px;\n  margin-bottom: 5px;\n  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\n}\n\n.item-icon {\n  width: 32px;\n  height: 32px;\n  background-repeat: no-repeat;\n  border-radius: 6px;\n}\n\n.item-icon-pointer {\n  cursor: var(--game-pointer);\n}\n\n.item-icon-off {\n  filter: grayscale(1);\n}\n\n.key-binding {\n    position: absolute;\n    bottom: 0px;\n    right: 4px;\n    color: white;   \n    font-size: 14px; \n    text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\n    font-family: 'Kim';\n}\n\n.item-qty {\n  position: absolute;\n  bottom: -1px;\n  left: 2px;\n  font-size: 14px;\n  background-color: rgba(0, 0, 0, 0.5);\n  /* Black background with 50% opacity */\n  border-radius: 10px;\n  color: white;\n}\n\n.info-box {\n  position: absolute;\n  top: 110%;\n  /* Positioned above the parent element */\n  left: 10px;\n  visibility: hidden;\n  opacity: 0;\n  transition: visibility 0s, opacity 0.2s linear;\n  /* Fade in/out */\n  z-index: 1;\n}\n\n.skill:hover .info-box,\n.item:hover .info-box {\n  visibility: visible;\n  /* Visible when parent is hovered over */\n  opacity: 1;\n}\n\n.info-box-title {\n  margin-top: 0;\n}\n\n.info-box-desc {\n  margin-top: 3px;\n  font-weight: normal;\n  font-size: 12px;\n}\n\n.mini {\n  margin-top: 5px;\n  display: inline-block;\n}\n\n@keyframes flash {\n  0% {\n    opacity: 1;\n  }\n\n  50% {\n    opacity: 0.5;\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n\n.flash-effect {\n  animation: flash 0.2s ease infinite;\n}\n\n\n\n.flex-grow {\n  flex-grow: 1;\n}\n\n\n\n.member-portrait {\n  position: relative;\n  width: 50px;\n  height: 50px;\n}\n\n.member-name {\n  font-size: 12px;\n}\n\n.member-index {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  color: white;\n  /* Or any color that matches your design */\n  font-size: 10px;\n  /* Adjust as needed */\n  background-color: rgba(0, 0, 0, 0.5);\n  /* Black background with 50% opacity */\n  border-radius: 10px;\n}\n\n\n.hp-fill {\n  height: 100%;\n  background-color: #32CD32;\n  /* green color for the filled part */\n  border-radius: 5px;\n  /* makes the bar rounded */\n}\n\n\n.mp-fill {\n  height: 100%;\n  background-color: #0099ff;\n  border-radius: 5px;\n  /* makes the bar rounded */\n}\n\n\n.cooldown-fill {\n  height: 100%;\n  background-color: #ffc400;\n  border-radius: 5px;\n  /* makes the bar rounded */\n}\n\n.blink {\n  animation: blink 0.25s linear;\n  animation-iteration-count: 3;\n}\n\n.homePage {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n}\n\n.content {\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  background-color: #080c15;\n  background-repeat: no-repeat;\n  background-position: 150% -100%;\n}\n\n.notificationBar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 25px;\n  background-color: #373636;\n  border-bottom: 2px solid black;\n}\n\n.mainContent {\n  flex: 1;\n  overflow-y: hidden;\n  display: flex;\n  flex-direction: column;\n  padding: 36px 0;\n}\n\n.page-header {\n  display: flex;\n  align-items: center;\n  padding: 5px;\n  justify-content: space-between;\n}\n\n.left-group {\n  display: flex;\n  align-items: center;\n  /* Align items vertically in the center */\n  flex: 1;\n  justify-content: flex-start;\n  /* Align items to the start (left) */\n}\n\n.left-group,\n.right-group {\n  flex: 1;\n}\n\n.header-capsules {\n  /* Centered content, adjust flex-basis to control width */\n  flex: 0 1 auto;\n}\n\n.page-icon {\n  scale: 0.7;\n}\n\n.page-title {\n  margin-left: 10px;\n  font-size: 4em;\n  /* Adjust as needed */\n  font-family: Kim;\n  color: white;\n  text-shadow: -5px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\n}\n\n.gold-container {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: flex-start;\n  border-radius: 50px;\n  padding: 10px 20px;\n  font-weight: bold;\n  border: 1px solid #CD853F;\n  font-size: 30px;\n  color: white;\n  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\n  font-family: Kim;\n}\n\n.gold-container::before,\n.gold-container::after {\n  content: \"\";\n  position: absolute;\n  height: 10px;\n  width: 10px;\n  /* Adjust to create the desired gap size */\n  background-color: #070507;\n  /* Match the background color */\n}\n\n.gold-container::before {\n  left: -12px;\n  /* Position the pseudo-element to cover the left border */\n}\n\n.gold-container::after {\n  right: -12px;\n  /* Position the pseudo-element to cover the right border */\n}\n\n.gold-icon {\n  margin-right: 10px;\n  /* Space between the icon and the text */\n  /* scale: 0.25; */\n  height: 32px;\n}\n\n.notificationBarButton {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  color: lightgrey;\n  padding: 5px;\n  cursor: pointer;\n  font-size: 14px;\n  background-color: #080c15;\n  border-radius: 3px;\n  margin-right: 5px;\n  font-weight: bold;\n}\n\n.notificationBarButton:hover {\n  filter: brightness(1.2);\n  cursor: pointer;\n}\n\n.notificationBarButton i {\n  position: relative;\n  margin-right: 5px;\n}\n\n.notificationBadge {\n  position: absolute;\n  bottom: -5px;\n  left: -8px;\n  padding: 2px 5px;\n  border-radius: 50%;\n  background-color: red;\n  color: white;\n  font-size: 8px;\n}\n\n.notificationList {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  width: 200px;\n  max-height: 200px;\n  overflow-y: auto;\n  border: 1px solid #B3B3B3;\n  background-color: white;\n  color: black;\n}\n\n.notificationItem {\n  padding: 10px;\n  border-bottom: 1px solid #B3B3B3;\n}\n\n.notificationItem:last-child {\n  border-bottom: none;\n}\n\n@keyframes animate-sprite {\n  0% {\n    background-position: -40px -40px;\n  }\n\n  33% {\n    background-position: -184px -40px;\n  }\n\n  66% {\n    background-position: -328px -40px;\n  }\n}\n\n@keyframes animate-sprite-celebrate {\n  0% {\n    background-position: -900px -184px;\n  }\n\n  33% {\n    background-position: -1044px -184px;\n  }\n\n  66% {\n    background-position: -1188px -184px;\n  }\n}\n\n.character-portrait {\n  height: 100px;\n  /* Adjust as needed */\n  width: 65px;\n  position: relative;\n  background-position: -40px -40px;\n  background-repeat: no-repeat;\n  animation: animate-sprite 0.7s steps(1) infinite;\n}\n\n.character-card {\n  position: relative;\n  display: flex;\n  align-items: center;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  cursor: pointer;\n  margin-bottom: 10px;\n  margin-right: 20px;\n  border: 2px solid #CD853F;\n  align-items: flex-start;\n  color: white;\n  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\n}\n\n.character-card.warrior {\n  /* background: linear-gradient(to right, #FFC600, #FF8000); */\n  background: linear-gradient(to right, #B22222, #FF6347);\n\n}\n\n.character-card.thief {\n  /* background: linear-gradient(to right, #4B0082, #8A2BE2); */\n  background: linear-gradient(to right, #006400, #32CD32);\n\n}\n\n.character-card.white-mage {\n  background: linear-gradient(to right, #FFFFFF, #A9A9A9);\n}\n\n.character-card.black-mage {\n  background: linear-gradient(to right, #000000, #696969);\n}\n\n.character-info {\n  display: flex;\n  flex-direction: column;\n}\n\n.character-name {\n  font-size: 1.2em;\n  font-weight: bold;\n  font-family: Kim;\n}\n\n.character-class {\n  font-size: 0.9em;\n  font-family: Kim;\n  /* color: #666; */\n}\n\n.level-badge {\n  position: absolute;\n  bottom: -10px;\n  right: -10px;\n  background-color: gold;\n  color: #fff;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 0.8em;\n  font-weight: bold;\n  font-family: Kim;\n  flex-direction: column;\n  box-shadow: 0 0 0 5px #070507, 0 0 0 7px #CD853F;\n  /* Creates a 10px transparent gap and a 2px border */\n  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\n}\n\n\n.level-badge .level-number {\n  font-size: 1.2em;\n}\n\n.roster {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.logo {\n  width: 50%;\n  /* Adjust as needed */\n  height: auto;\n}\n\n.rank-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 32px;\n  width: 1024px;\n  margin: 0 auto;\n}\n\n.rank-content .flexContainer {\n  width: 100%;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.rank-tab-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n  padding-top: 36px;\n}\n\n.leaderboard-table {\n  border-collapse: separate;\n  border-spacing: 0;\n  border: 2px solid white;\n  border-radius: 10px;\n  overflow: hidden;\n  width: 100%;\n  margin: auto;\n  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\n}\n\n.leaderboard-table thead tr {\n  background: linear-gradient(to right, darkblue, lightblue);\n}\n\n.leaderboard-table th {\n  font-family: 'Kim', sans-serif;\n  color: white;\n  cursor: pointer;\n}\n\n.leaderboard-table tr:nth-child(even) {\n  background-color: #e0e0e0;\n}\n\n.leaderboard-table tr:nth-child(odd) {\n  background-color: #d7d7d7;\n}\n\n.leaderboard-table td {\n  text-align: center;\n  font-family: 'Kim';\n  color: white;\n  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\n  padding-right: 15px;\n}\n\n.leaderboard-table tr:hover {\n  background-color: #c0c0c0;\n  /* ddd */\n}\n\n.leaderboard-table th div {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.leaderboard-table th div span:last-child {\n  margin-left: 5px;\n}\n\n.golden-star {\n  color: gold;\n}\n\n.hidden {\n  display: none;\n}\n\n.leaderboard-table tr.highlighted-row {\n  background-color: gold;\n  border: 2px solid black;\n  margin-left: -5px;\n  margin-right: -5px;\n}\n\n.button-container {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: flex-start;\n  background-color: gold;\n  /* Warmer pastel color */\n  border-radius: 50px;\n  /* Adjust to create an elliptical shape */\n  padding: 10px 20px;\n  /* Adjust for size */\n  font-weight: bold;\n  box-shadow: 0 0 0 10px #070507, 0 0 0 12px #CD853F;\n  /* Creates a 10px transparent gap and a 2px border */\n  font-size: 30px;\n  color: white;\n  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\n  font-family: Kim;\n}\n\n.button-container::before,\n.button-container::after {\n  content: \"\";\n  position: absolute;\n  height: 10px;\n  width: 10px;\n  /* Adjust to create the desired gap size */\n  background-color: #070507;\n  /* Match the background color */\n}\n\n.button-container::before {\n  left: -12px;\n  /* Position the pseudo-element to cover the left border */\n}\n\n.button-container::after {\n  right: -12px;\n  /* Position the pseudo-element to cover the right border */\n}\n\n.button {\n  cursor: pointer;\n  margin: 10px;\n}\n\n.button:hover {\n  filter: brightness(1.1);\n}\n\n.button:active {\n  transform: scale(0.95);\n}\n\n.player-tab {\n  position: relative;\n  margin-top: 10px;\n  margin-left: 10px;\n  z-index: 2;\n  /* max-width: 350px; */\n  align-self: start;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\n  background-color: #F9F6EE;\n  border-radius: 15px;\n}\n\n.player-bars {\n  margin-right: 10px;\n  width: 200px;\n}\n\n.character-full {\n  margin-top: 20px;\n  margin-left: 10px;\n  position: relative;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\n  background-color: #F9F6EE;\n  border-radius: 15px;\n  width: 500px;\n}\n\n.character-header {\n  position: relative;\n  background: linear-gradient(to right, #874255, #edcfb7, transparent);\n  border-top-left-radius: inherit;\n  border-top-right-radius: inherit;\n  height: 50px;\n  padding: 5px;\n  padding-left: 15px;\n  overflow: hidden;\n}\n\n.character-header-arena {\n  position: relative;\n  /* background: linear-gradient(to right, #874255, #edcfb7, transparent); */\n  background: linear-gradient(to right, rgb(79, 79, 227), lightblue, transparent);\n  border-top-left-radius: inherit;\n  border-top-right-radius: inherit;\n  height: 30px;\n  padding: 5px;\n  padding-left: 15px;\n  overflow: hidden;\n  text-shadow: 2px 2px 4px black;\n\n}\n\n.character-header-name {\n  position: absolute;\n  font-family: Kim;\n  color: white;\n  font-size: 30px;\n  /* text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black; */\n  top: 0;\n  text-shadow: 2px 2px 4px black;\n\n}\n\n.character-header-name-shadow {\n  position: absolute;\n  top: -30px;\n  left: 15px;\n  font-family: Kim;\n  color: white;\n  font-size: 80px;\n  opacity: 0.15;\n}\n\n.character-header-class {\n  position: absolute;\n  top: 35px;\n  left: 15px;\n  font-family: Kim;\n  color: white;\n  font-size: 15px;\n  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\n  font-style: italic;\n}\n\n\n.character-full-content {\n  display: flex;\n  justify-content: space-between;\n  padding: 10px;\n  font-family: Kim;\n  color: white;\n  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\n}\n\n.character-full-level {\n  font-size: 20px;\n}\n\n.level-area {\n  display: flex;\n  width: 50%;\n}\n\n.character-full .level-badge {\n  left: 10px;\n  top: 70px;\n}\n\n.hud-actions {\n  margin-top: -10px;\n}\n\n.xp-area {\n  margin-left: 60px;\n  flex-grow: 1;\n}\n\n.xp-bar-bg {\n  background-color: black;\n  border-radius: 50px;\n  overflow: hidden;\n}\n\n.xp-bar {\n  height: 5px;\n  background: linear-gradient(to right, darkblue, lightblue);\n  border-radius: 50px;\n}\n\n.hud-bar-bg {\n  background-color: darkred;\n  border-radius: 50px;\n  overflow: hidden;\n}\n\n.hud-bar {\n  height: 10px;\n  border-radius: 50px;\n}\n\n\n.cooldown-bar {\n  background: gold;\n}\n\n.bar-title {\n  font-style: italic;\n  margin-top: 2px;\n}\n\n.bigger-number {\n  font-size: 25px;\n  margin-left: 5px;\n}\n\n.smaller-number {\n  font-size: 12px;\n  margin-left: 5px;\n}\n\n.shop-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 10px;\n  margin-top: 20px;\n  width: calc(100% - 30px);\n}\n\n.shop-item-card {\n  position: relative;\n  border: 1px solid #ccc;\n  background-color: #F9F6EE;\n  border-radius: 15px;\n  cursor: pointer;\n}\n\n.shop-item-card:hover {\n  background-color: #ffffff;\n}\n\n.shop-item-image {\n  width: 36px;\n  height: 36px;\n  min-width: 36px;\n  min-height: 36px;\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n}\n\n.shop-item-name {\n  margin-top: 10px;\n}\n\n.shop-item-card-header {\n  position: relative;\n  background: linear-gradient(to right, rgb(79, 79, 227), lightblue, transparent);\n  border-top-left-radius: inherit;\n  border-top-right-radius: inherit;\n  height: 20px;\n  padding: 5px;\n  padding-left: 15px;\n  overflow: hidden;\n  font-family: Kim;\n}\n\n.shop-item-card-name {\n  position: absolute;\n  top: 0;\n  font-size: 20px;\n  color: white;\n  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\n\n}\n\n.shop-item-card-name-shadow {\n  position: absolute;\n  top: -30px;\n  left: 15px;\n  font-family: Kim;\n  color: white;\n  font-size: 80px;\n  opacity: 0.15;\n}\n\n.shop-item-card-content {\n  padding: 10px;\n  height: 150px;\n  display: flex;\n}\n\n.shop-item-card-content-info {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.shop-item-details {\n  padding-left: 10px;\n}\n\n.shop-item-card-capsules {\n  display: flex;\n  flex-direction: row;\n  margin-top: 10px;\n  justify-content: flex-end;\n}\n\n.socials {\n  margin-top: 20px;\n}\n\n.socials img {\n  width: 64px;\n  /* height: 64px; */\n}\n\n.twitterIconContainer {\n  background-color: black;\n  border-radius: 5px;\n  /* Adjust as needed */\n  padding-left: 3px;\n  padding-right: 3px;\n  margin-top: 2px;\n}\n\n.twitterIconContainer i {\n  color: white;\n}\n\n.socials-bar {\n  padding-left: 5px;\n}\n\n.stats-area {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  grid-template-rows: repeat(2, 1fr);\n  gap: 10px;\n  margin-top: 30px;\n  width: 50%;\n}\n\n.stats-badge {\n  background-color: black;\n  color: white;\n  border-radius: 50%;\n  padding: 10px;\n  width: 10px;\n  height: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 5px;\n}\n\n.stats-value {\n  color: black;\n  margin: 5px;\n}\n\n.character-full-stats {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.description-area {\n  display: grid;\n  align-items: start;\n  grid-template-columns: repeat(2, auto);\n  grid-template-rows: repeat(2, auto);\n  gap: 5px;\n  margin-top: 5px;\n}\n\n.dialog {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 1000;\n  border: 2px solid #ccc;\n  background-color: #F9F6EE;\n  border-radius: 15px;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\n  font-family: Kim;\n  color: #4a4947;\n}\n\n/* .login-dialog {\n  width: 300px;\n} */\n\n\n.closebtn {\n  cursor: pointer;\n  color: rgb(222, 24, 24);\n  position: absolute;\n  top: -10px;\n  right: -8px;\n  font-size: 30px;\n}\n\n.closebtn:hover {\n  filter: brightness(1.2);\n}\n\n.quantity-container {\n  display: flex;\n}\n\n.shop-qty {\n  width: 20px;\n  text-align: center;\n  margin: 0 -5px;\n}\n\n.qty-button {\n  margin: 0;\n  padding: 0 5px;\n  cursor: pointer;\n}\n\n\n.qty-button,\n.shop-qty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 20px;\n  /* Adjust as needed */\n  width: 20px;\n  /* Adjust as needed */\n  border: none;\n  background: none;\n  border: 1px solid black;\n}\n\n.small-button {\n  width: 60px;\n  height: 30px;\n  padding: 5px;\n  font-size: 25px;\n  box-shadow: 0 0 0 5px #070507, 0 0 0 6px #CD853F;\n  /* Creates a 10px transparent gap and a 2px border */\n\n}\n\n.inventory-full {\n  margin-top: 20px;\n  margin-left: 10px;\n  position: relative;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\n  background-color: #F9F6EE;\n  border-radius: 15px;\n  width: 60%;\n}\n\n.inventory-header {\n  position: relative;\n  background: linear-gradient(to right, #2f150e, #d8b085, transparent);\n  border-top-left-radius: inherit;\n  border-top-right-radius: inherit;\n  height: 50px;\n  padding: 5px;\n  padding-left: 15px;\n  overflow: hidden;\n}\n\n.inventory-header-name {\n  position: absolute;\n  font-family: Kim;\n  color: white;\n  font-size: 45px;\n  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\n  top: 0;\n  padding-left: 100px;\n  display: flex;\n  justify-content: space-between;\n  width: calc(100% - 120px);\n}\n\n.inventory-header-name-shadow {\n  position: absolute;\n  top: -30px;\n  left: 15px;\n  font-family: Kim;\n  color: white;\n  font-size: 80px;\n  opacity: 0.15;\n}\n\n/* .inventory-capacity {\n  font-size: 30px;\n  vertical-align: middle;\n} */\n\n.inventory-header-image {\n  position: relative;\n  left: -10px;\n  /* Adjust this value to control how much the image spills over to the left */\n}\n\n.inventory-full-content {\n  padding: 10px;\n  font-family: Kim;\n  color: white;\n  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(45px, 1fr));\n  grid-gap: 5px;\n\n}\n\n.character-inventory-container {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 24px 0;\n  flex-wrap: wrap;\n  width: 100%;\n  max-width: 100%;\n}\n\n.purchase-dialog {\n  width: auto;\n}\n\n.purchase-item {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.purchase-item-name {\n  font-weight: bold;\n}\n\n.purchase-quantity {\n  width: 30px;\n  text-align: center;\n}\n\n.purchase-quantity-selector {\n  display: flex;\n  align-items: center;\n  margin-left: 5px;\n}\n\n\n.purchase-quantity-selector input.quantity {\n  text-align: center;\n  border-top: 1px solid #000;\n  border-bottom: 1px solid #000;\n}\n\n.purchase-total {\n  display: flex;\n  margin-bottom: 20px;\n}\n\n.purchase-total-amount {\n  font-weight: bold;\n}\n\n.purchase-buy-button {\n  padding: 10px;\n  border: none;\n  background-color: gold;\n  color: #fff;\n  cursor: pointer;\n  font-family: 'Kim';\n  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\n  font-size: 20px;\n  border-radius: 5px;\n}\n\n.purchase-buy-button:hover {\n  filter: brightness(1.1);\n}\n\n.purchase-adjust {\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.endgame {\n  background: linear-gradient(rgba(10, 10, 10, 0.9), rgba(20, 20, 20, 0.9));\n  /* Dark grey, almost black background with slight transparency */\n  position: fixed;\n  z-index: 20;\n  width: 100%;\n  height: 100%;\n  padding: 10px;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  font-family: \"Kim\";\n}\n\n.endgame-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.endgame-rewards {\n  display: flex;\n  justify-content: center;\n  color: white;\n  font-size: 30px;\n  font-family: 'Kim';\n}\n\n.endgame-title {\n  font-family: 'Kim';\n  font-size: 50px;\n  color: white;\n  font-style: italic;\n}\n\n.endgame-title,\n.endgame-spacer {\n  flex-basis: content;\n  flex-grow: 1;\n}\n\n.endgame-gold-logo {\n  font-size: 35px;\n  color: gold;\n  font-style: italic;\n  /* text-shadow: -1px 0 white, 0 1px white, 1px 0 white, 0 -1px white; */\n  /* text-shadow: 2px 2px 10px red;  */\n  margin-right: 10px;\n}\n\n.endgame-xp {\n  margin-left: 10px;\n}\n\n.endgame-xp,\n.endgame-gold {\n  display: flex;\n  align-items: center;\n}\n\n.endgame-gold-value,\n.endgame-xp-value {\n  padding-left: 10px;\n  display: inline-block;\n  min-width: 60px;\n  /* Adjust this width as needed */\n  text-align: right;\n}\n\n.endgame-xp-logo {\n  font-size: 35px;\n  color: gold;\n  font-style: italic;\n  /* text-shadow: -1px 0 white, 0 1px white, 1px 0 white, 0 -1px white; */\n  /* text-shadow: 2px 2px 10px rgb(3, 141, 40);  */\n  margin-right: 10px;\n}\n\n::-webkit-scrollbar {\n  width: 8px;\n  /* Adjust the width of the scrollbar */\n  background: url('@assets/shop/slider_bar.png');\n  /* Add your image */\n}\n\n/* Scrollbar Thumb */\n::-webkit-scrollbar-thumb {\n  background-color: #888;\n  border-radius: 8px;\n  background-image: url('@assets/shop/slider_handle.png');\n  /* Replace with your image path */\n  background-size: 100% 100%;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n\n.toast {\n  border: 2px solid #ffbf00;\n}\n\n.tour-step {\n  border: 2px solid #ffbf00;\n  background-color: #242b37;\n  padding: 10px;\n  text-align: center;\n}\n\n.shepherd-button {\n  background-color: #ffbf00;\n  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\n  font-family: 'Kim';\n  color: white;\n}\n\n.shepherd-button:not(:disabled):hover {\n  background-color: #ffaa00;\n  color: white;\n}\n\n.shepherd-text {\n  /* font-family: 'Kim' ; */\n  color: white;\n}\n\n.shepherd-arrow,\n.shepherd-arrow:before {\n  width: 16px;\n  height: 16px;\n  position: absolute;\n  z-index: -1;\n}\n\n.shepherd-arrow:before {\n  content: \"\";\n  transform: rotate(45deg);\n  background: #242b37;\n}\n\n/* Top arrow */\n.shepherd-element[data-popper-placement^=bottom]>.shepherd-arrow:before {\n  border-top: 2px solid #ffbf00;\n  border-left: 2px solid #ffbf00;\n}\n\n/* Bottom arrow */\n.shepherd-element[data-popper-placement^=top]>.shepherd-arrow:before {\n  border-bottom: 2px solid #ffbf00;\n  border-right: 2px solid #ffbf00;\n}\n\n/* Left arrow */\n.shepherd-element[data-popper-placement^=right]>.shepherd-arrow:before {\n  border-left: 2px solid #ffbf00;\n  border-bottom: 2px solid #ffbf00;\n  left: 0px;\n}\n\n/* Right arrow */\n.shepherd-element[data-popper-placement^=left]>.shepherd-arrow:before {\n  border-top: 2px solid #ffbf00;\n  border-right: 2px solid #ffbf00;\n  right: 0px;\n}\n\n.shepherd-cancel-icon {\n  position: absolute;\n  top: -10px;\n  right: -10px;\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  background: rgb(255, 68, 68);\n  border-radius: 50%;\n  color: white;\n  font-size: 30px;\n  line-height: 22px;\n  text-align: center;\n  cursor: pointer;\n  z-index: 1;\n  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\n  font-family: 'Kim';\n}\n\n.shepherd-cancel-icon:hover {\n  background: rgb(224, 0, 0);\n  color: white;\n}\n\na:-webkit-any-link {\n  text-decoration: none;\n}\n\n.normalCursor {\n  cursor: url('../../public/pointers/general_pointer.png'), auto;\n}\n\n.pointerCursor {\n  cursor: var(--game-pointer);\n}\n\n.swordCursor {\n  cursor: url('../../public/pointers/attack_pointer.png'), auto;\n}\n\n.spellCursor {\n  cursor: url('../../public/pointers/spell_pointer.png'), auto;\n}\n\n.itemCursor {\n  cursor: url('../../public/pointers/item_cursor.png'), auto;\n}\n\n.firebaseui-container {\n  text-shadow: none;\n}\n\n.anonymous-warning {\n  position: fixed;\n  bottom: 20px;\n  left: 20px;\n  z-index: 9999;\n  max-width: 300px;\n  font-size: 14px;\n\n  background-color: #242b37;\n  border: 1px solid #0096a1;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  text-align: center;\n  padding: 10px;\n  width: 400px;\n  font-family: Kim;\n  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\n  color: white;\n}\n\n.sign-up-btn-smol {\n  border-radius: 8px;\n  /* Rounded corners */\n  color: #ffffff;\n  margin-top: 10px;\n  cursor: pointer;\n  width: 80%;\n  /* Adjust width as needed */\n  text-align: center;\n  transition: all 0.3s ease;\n  /* Smooth hover and active transition */\n  font-family: Kim;\n  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\n  background-color: #ffcc00;\n  /* Golden color */\n  border: 2px solid #ffaa00;\n  /* Slightly darker border for depth */\n  font-size: 14px;\n  padding: 6px 12px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  /* Depth effect */\n}\n\n.sign-up-btn-smol:hover {\n  background-color: #ffaa00;\n  /* Slightly darker on hover */\n  border-color: #ff9900;\n  /* Darker border on hover */\n  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);\n  /* Deeper shadow on hover */\n}\n\n.sign-up-btn-smol:active {\n  transform: scale(0.95);\n  /* Scale down on press */\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  /* Less shadow on press */\n}\n\n\n.login-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.login-modal-dialog {\n  background-color: white;\n  border-radius: 8px;\n  padding: 20px;\n  width: 90%;\n  max-width: 400px;\n  max-height: 90vh;\n  overflow-y: auto;\n  position: relative;\n\n  background-color: #242b37;\n  border: 1px solid #0096a1;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  text-align: center;\n  padding: 10px;\n  width: 400px;\n  font-family: Kim;\n  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\n  color: white;\n}\n\n\n.dialog-content h2 {\n  margin-bottom: 20px;\n}\n\n.login-header {\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n#firebaseui-auth-container {\n  width: 100%;\n}\n\n\n.popup-highlight {\n  animation: highlight-pulse 1s ease-in-out infinite;\n  position: relative;\n  filter: drop-shadow(0 0 6px rgba(0, 255, 255, 0.5));\n}\n\n.feature-highlight {\n  animation: highlight-pulse 1s ease-in-out infinite;\n  position: relative;\n  filter: drop-shadow(0 0 6px rgba(0, 255, 255, 0.5));\n}\n\n@keyframes highlight-pulse {\n  0% {\n    transform: scale(1);\n    filter: drop-shadow(0 0 6px rgba(0, 255, 255, 0.5));\n  }\n  50% {\n    transform: scale(1.03);\n    filter: drop-shadow(0 0 12px rgba(0, 255, 255, 0.8));\n  }\n  100% {\n    transform: scale(1);\n    filter: drop-shadow(0 0 6px rgba(0, 255, 255, 0.5));\n  }\n}\n\n.team-page {\n  width: 100%;\n  max-width: 100vw;\n  overflow-x: hidden;\n  padding: 0 16px;\n  box-sizing: border-box;\n}\n\n.character-sheet-skeleton {\n  width: 100%;\n  max-width: 434px;\n  margin: 2px 0;\n}\n\n.inventory-skeleton {\n  width: 100%;\n  max-width: 560px;\n  margin: 2px 0;\n}\n\n@media (max-width: 1024px) {\n  .character-inventory-container {\n    padding: 16px 0;\n  }\n}\n\n@media (max-width: 768px) {\n  .team-page {\n    padding: 0 8px;\n  }\n  \n  .character-inventory-container {\n    gap: 16px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
